import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase } from 'vnpost-shared';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { WeightConfigurationService } from '../../services/weight-configuration.service';
import { UnitService } from '../../../core/services/unit-service';
import { ProductService } from '../../services/product.service';
import { CategoryService } from '../../services/category.service';

@Component({
  selector: 'app-weight-configuration-edit',
  templateUrl: './weight-configuration-edit.component.html',
  styleUrls: ['./weight-configuration-edit.component.css']
})
export class WeightConfigurationEditComponent extends SecondPageEditBase implements OnInit {

  listCategory: { label: string; value: string }[] = [];
  listProduct: { label: string; value: string }[] = [];
  listUnit: { label: string; value: string }[] = [];

  listPeriod: { label: string, value: number }[] = [
    { label: '1 tháng', value: 1 },
    { label: '2 tháng', value: 2 },
    { label: '3 tháng', value: 3 },
    { label: '4 tháng', value: 4 },
    { label: '5 tháng', value: 5 },
    { label: '6 tháng', value: 6 },
    { label: '7 tháng', value: 7 },
    { label: '8 tháng', value: 8 },
    { label: '9 tháng', value: 9 },
    { label: '10 tháng', value: 10 },
    { label: '11 tháng', value: 11 },
    { label: '12 tháng', value: 12 },
    { label: 'Tái tục', value: 13 },
  ] 
  listStatus: { label: string; value: number }[] = [{label: "Đang áp dụng", value: 1}, {label: "Ngừng áp dụng", value: 0}];
  unitCode: any;

  constructor(
    protected _weightConfigurationService: WeightConfigurationService,
    protected _categoryService: CategoryService,
    protected _productService: ProductService,
    protected _injector: Injector,
    private _unitService: UnitService
  ) {
    super(_weightConfigurationService, _injector);
    this.formGroup = new UntypedFormGroup({
      categoryId: new UntypedFormControl('', [Validators.required]),
      productId: new UntypedFormControl('', [Validators.required]),
      status: new UntypedFormControl('', [Validators.required]),
      unitCode: new UntypedFormControl('', [Validators.required]),
      configurationType: new UntypedFormControl(''),
      salesWeight: new UntypedFormControl(''),
      totalWeight: new UntypedFormControl(''),
      receivedWeight: new UntypedFormControl(''),
      revenue: new UntypedFormControl(''),
      totalRemuneration: new UntypedFormControl(''),
      remunerationReceived: new UntypedFormControl(''),
      paymentPeriod: new UntypedFormControl(''),
      startDate: new UntypedFormControl(''),
      endDate: new UntypedFormControl(''),
      percentConfig: new UntypedFormControl(''),
      amountConfig: new UntypedFormControl(''),
    });
  }

  ngOnInit() {

  }


  onShowPopup(itemId: any) {
    if (this.listUnit.length == 0) {
      this.getListUnit();
    }
    if (this.listProduct.length == 0) {
      this.getListCategory();
    }
    this.validationSummary.resetErrorMessages();
    this.resetForm();

    if (itemId > 0) {
      this._weightConfigurationService.getWeightConfiguration(itemId).then(async rs => {
        this.itemDetail = rs.data;
        this.itemDetail.percentConfig = this.itemDetail.configurationType === 1;
        this.itemDetail.amountConfig = !this.itemDetail.percentConfig;
        this.itemDetail.startDate = new Date(this.itemDetail.startDate);
        this.itemDetail.endDate = new Date(this.itemDetail.endDate);
        // this.itemDetail.paymentPeriod = this.itemDetail.paymentPeriod ? this.itemDetail.paymentPeriod : 0;
        this.unitCode = this.itemDetail.unitCode ? this.itemDetail.unitCode.split(',') : [];
        if (this.itemDetail.categoryId) {
          this.onChangeCategory();
        }
      }, error => {
        this._notifierService.showWarning(this._translateService.instant('MESSAGE.NOT_FOUND_ERROR'));
      });
    }
  }

  getListCategory() {
    const model = {
      status: 1
    }
    this._categoryService.getListCategory(model).then(res => {
      this.listCategory = res?.data.map(x => ({label: `${x.code} - ${x.name}`, value: x.id}));
    },err => {
      this.listCategory = []
    })
  }

  onChangeCategory() {
    const model = {
      categoryId: this.itemDetail.categoryId,
      status: 1
    }
    this._productService.getListProduct(model).then(res => {
      this.listProduct = res?.data.map(x => ({label: `${x.code} - ${x.name}`, value: x.id}));
    },err => {
      this.listProduct = []
    })
  }

  getListUnit() {
    this._unitService.getTreeUnitByUnitCode(this.currentUser.unitCode)
      .then(response => {
        this.listUnit = response.data.map(r => ({label: `- ${r.unitName} (${r.unitCode})`, value: r.unitCode}));
      }, error => {
        this.listUnit = [];
      });

  }

  onChangePercentConfig() {
    this.itemDetail.amountConfig = !this.itemDetail.percentConfig;
    if (!this.itemDetail.percentConfig) {
      this.itemDetail.salesWeight = 0;
      this.itemDetail.totalWeight = 0;
      this.itemDetail.receivedWeight = 0;
    }
    else {
      this.itemDetail.revenue = 0;
      this.itemDetail.totalRemuneration = 0;
      this.itemDetail.remunerationReceived = 0;
    }
  }

  onChangeAmountConfig() {
    this.itemDetail.percentConfig = !this.itemDetail.amountConfig;
    if (!this.itemDetail.percentConfig) {
      this.itemDetail.salesWeight = 0;
      this.itemDetail.totalWeight = 0;
      this.itemDetail.receivedWeight = 0;
    }
    else {
      this.itemDetail.revenue = 0;
      this.itemDetail.totalRemuneration = 0;
      this.itemDetail.remunerationReceived = 0;
    }
  }

  async save() {
    this.submitting = true;

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }

    if (this.itemDetail.salesWeight && (this.itemDetail.salesWeight < 0 || this.itemDetail.salesWeight > 100)) {
      this.submitting = false;
      this._notifierService.showError('Trọng số hưởng phần trăm doanh số bán không hợp lệ');
      return;
    }

    if (this.itemDetail.totalWeight && (this.itemDetail.totalWeight < 0)) {
      this.submitting = false;
      this._notifierService.showError('Trọng số hưởng phần trăm theo tổng thù lao không hợp lệ');
      return;
    }

    if (this.itemDetail.receivedWeight && (this.itemDetail.receivedWeight < 0 || this.itemDetail.receivedWeight > 100)) {
      this.submitting = false;
      this._notifierService.showError('Trọng số hưởng phần trăm theo thù lao được nhận không hợp lệ');
      return;
    }

    if (this.itemDetail.revenue && (this.itemDetail.revenue < 0)) {
      this.submitting = false;
      this._notifierService.showError('Doanh thu không hợp lệ');
      return;
    }

    if (this.itemDetail.totalRemuneration && (this.itemDetail.totalRemuneration < 0)) {
      this.submitting = false;
      this._notifierService.showError('Tổng thù lao không hợp lệ');
      return;
    }

    if (this.itemDetail.remunerationReceived && (this.itemDetail.remunerationReceived < 0)) {
      this.submitting = false;
      this._notifierService.showError('Thù lao được nhận không hợp lệ');
      return;
    }

    if (!this.itemDetail.startDate || !this.itemDetail.endDate || this.itemDetail.startDate > this.itemDetail.endDate)  {
      this.submitting = false;
      this._notifierService.showError('Thời gian áp dụng không hợp lệ');
      return;
    }

    this.onUpdate();
  }

  onUpdate() {
    var model = Object.assign({...this.itemDetail}, {
      unitCode: this.unitCode?.join(','),
      configurationType: this.itemDetail.percentConfig ? 1 : 2,
      startDate: `${this.itemDetail.startDate.getFullYear()}-${(this.itemDetail.startDate.getMonth() + 1).toString().padStart(2, '0')}-${this.itemDetail.startDate.getDate().toString().padStart(2, '0')}`,
      endDate: `${this.itemDetail.endDate.getFullYear()}-${(this.itemDetail.endDate.getMonth() + 1).toString().padStart(2, '0')}-${this.itemDetail.endDate.getDate().toString().padStart(2, '0')}`,
      paymentPeriod: this.itemDetail.paymentPeriod ? this.itemDetail.paymentPeriod : null,
    })
    this._weightConfigurationService.update(this.itemDetail.id, model)
      .then(response => {
        this.closePopupMethod(true);
        this._notifierService.showUpdateDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      }, error => {
        if (error?.error?.message) 
          this._notifierService.showError(error?.error?.message);
        else this._notifierService.showUpdateDataFailed();
        this.submitting = false;
      });
  }
}
